import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import themes from "../../config/theme";

const LoopingImageAnimation = () => {
  const TitlebarHeight = useSelector((state) => state.website.TitlebarHeight);
  const location = useLocation()
  const screenType = useSelector((state) => state.website.screenType);

  const currentTheme = useSelector((state) => state.website.theme);
  const selectedTheme = themes[currentTheme] || themes.default(location, TitlebarHeight, screenType); // Use selected theme
  const images = selectedTheme.imagesConfig.map((image) => ({
    ...image,
    style: {
      ...image.style,
      width: image.style.width(location, TitlebarHeight, screenType),
    },
  }));

  const [currentImageIndex, setCurrentImageIndex] = useState(
    images.length > 0 ? Math.floor(Math.random() * images.length) : 0
  );
  const [activeDirection, setActiveDirection] = useState("");
  const [verticalAlign, setVerticalAlign] = useState("");
  const headerHeight = useSelector((state) => state.website.headerHeight);

  useEffect(() => {
    if (!images.length) return; // Exit if images array is empty.

    const currentImage = images[currentImageIndex];
    if (!currentImage) return; // Protect against invalid currentImageIndex.

    setActiveDirection(
      currentImage.originEnd === "left" ? "leftToRight" : "rightToLeft"
    );
    setVerticalAlign(currentImage.verticalAlign);

    const timer = setTimeout(() => {
      setActiveDirection("");
      setVerticalAlign("");
      let nextImageIndex;

      // Ensure the next image index is different from the current index
      do {
        nextImageIndex = Math.floor(Math.random() * images.length);
      } while (nextImageIndex === currentImageIndex);

      setCurrentImageIndex(nextImageIndex);
      // setCount((prevCount) => prevCount + 1);
    }, currentImage.duration);

    return () => clearTimeout(timer);
  }, [ currentImageIndex, images]);

  const renderAnimation = () => {
    if (!images.length) return null; // Exit if images array is empty.

    const currentImage = images[currentImageIndex];
    if (!currentImage) return null; // Protect against invalid currentImageIndex.

    const animationStyle =
      activeDirection === "leftToRight"
        ? {
            initial: { x: "100%" },
            animate: { x: "100vw" },
            transition: {
              duration: currentImage.duration / 1000,
              ease: "linear",
            },
          }
        : {
            initial: { x: "100vw" },
            animate: { x: "-100%" },
            transition: {
              duration: currentImage.duration / 1000,
              ease: "linear",
            },
          };

    const verticalAlignStyle =
      verticalAlign === "center"
        ? {
            top: "50%",
            transform: "translateY(-50%)", // Centers vertically
          }
        : verticalAlign === "top"
        ? { top: 0 }
        : verticalAlign === "bottom"
        ? { bottom: 0 }
        : {};

    return (
      <motion.img
        src={currentImage.imagePath}
        style={{
          position: "absolute",
          ...currentImage.style,
          ...verticalAlignStyle,
          zIndex: -1000,
        }}
        {...animationStyle}
      />
    );
  };


  return (
    <div
      style={{
        // position: 'absolute',
        // width: '100%',
        zIndex: 1,

        height: headerHeight,
      }}
    >
      {activeDirection && renderAnimation()}
    </div>
  );
};

// Animation Items

const animationItems = [];

const App = () => {
  return <LoopingImageAnimation images={animationItems} />;
};

export default App;
